import React from 'react'
const SvgChoose6 = props => (
  <svg viewBox='0 0 500 179.35' {...props}>
    <defs>
      <style>
        {
          '.choose6_svg__cls-1,.choose6_svg__cls-3{fill:none}.choose6_svg__cls-1{stroke:#7c8aa3}.choose6_svg__cls-1,.choose6_svg__cls-3{stroke-miterlimit:10}.choose6_svg__cls-1{stroke-width:2px}.choose6_svg__cls-2{fill:#ebeced}.choose6_svg__cls-3{stroke:#ebeced}.choose6_svg__cls-4,.choose6_svg__cls-5{fill:#8796aa}.choose6_svg__cls-5{font-size:14.08px;font-family:Helvetica;letter-spacing:.02em}.choose6_svg__cls-7{letter-spacing:.01em}.choose6_svg__cls-11{fill:#fd5c1f}.choose6_svg__cls-12{fill:#252a3a}'
        }
      </style>
    </defs>
    <g id='choose6_svg__\u56FE\u5C42_2' data-name='\u56FE\u5C42 2'>
      <g id='choose6_svg__\u56FE\u5C42_1-2' data-name='\u56FE\u5C42 1'>
        <rect className='choose6_svg__cls-1' x={342.88} y={17.29} width={141.16} height={97.72} rx={10.86} />
        <rect className='choose6_svg__cls-1' x={20.57} y={17.29} width={141.16} height={97.72} rx={10.86} />
        <path
          className='choose6_svg__cls-2'
          d='M90.7 144.94H11.91c-2.46 0-6.12.15-7-1.87-1.2-2.87 1.07-4.54 2.69-6.67 8.94-10.48 11.48-16.27 28.73-16.24 38 1.29 76 .49 114 .32 4.07 0 6.78 1.1 10.46 4.33 4 3.7 9.16 7.79 13.61 11.87 1.77 1.63 4.34 3.56 2.75 6.5-1.34 2.48-4.14 1.76-6.43 1.77h-43.55z'
        />
        <rect className='choose6_svg__cls-3' x={52.12} y={44.41} width={78.06} height={17.92} rx={2} />
        <rect className='choose6_svg__cls-3' x={52.12} y={68.72} width={78.06} height={17.92} rx={2} />
        <path
          className='choose6_svg__cls-4'
          d='M63.46 53.85a2.56 2.56 0 10-2.85-2.54 2.55 2.55 0 002.85 2.54zm-.29.75c-1.71 0-5.12 1-5.12 2.92v1.1a.37.37 0 00.36.37h9.51a.38.38 0 00.37-.37v-1.1c0-1.94-3.41-2.92-5.12-2.92zM66.15 76.4v-1.49a3 3 0 10-6 0v1.49h-1.46v7h9v-7zm-5-1.49a2 2 0 014 0v1.49h-4zm5.47 7.46h-7v-5h7z'
        />
        <path
          className='choose6_svg__cls-2'
          d='M413 144.94h-78.79c-2.46 0-6.12.15-7-1.87-1.2-2.87 1.08-4.54 2.69-6.67 8.95-10.48 11.49-16.27 28.73-16.24 38 1.29 76 .49 114 .32 4.07 0 6.79 1.1 10.47 4.33 4 3.7 9.16 7.79 13.6 11.87 1.77 1.63 4.34 3.56 2.75 6.5-1.34 2.48-4.14 1.76-6.42 1.77h-43.56z'
        />
        <rect className='choose6_svg__cls-3' x={374.43} y={44.41} width={78.06} height={17.92} rx={2} />
        <rect className='choose6_svg__cls-3' x={374.43} y={68.72} width={78.06} height={17.92} rx={2} />
        <path
          className='choose6_svg__cls-4'
          d='M385.63 53.85a2.56 2.56 0 10-2.85-2.54 2.55 2.55 0 002.85 2.54zm-.29.75c-1.71 0-5.12 1-5.12 2.92v1.1a.37.37 0 00.36.37h9.51a.37.37 0 00.36-.37v-1.1c0-1.94-3.4-2.92-5.11-2.92zM388.32 76.4v-1.49a3 3 0 10-6 0v1.49h-1.49v7h9v-7zm-5-1.49a2 2 0 014 0v1.49h-4zm5.47 7.46h-7v-5h7z'
        />
        <text className='choose6_svg__cls-5' transform='translate(41.75 171.73)'>
          {'Raysync Client'}
        </text>
        <text
          transform='matrix(.95 0 0 1 366.57 172.58)'
          letterSpacing='.02em'
          fontSize={14.08}
          fontFamily='Helvetica'
          fill='#8796aa'
        >
          {'Raysync Client'}
        </text>
        <text className='choose6_svg__cls-5' transform='translate(194.12 107.32)'>
          {'P2'}
          <tspan className='choose6_svg__cls-7' x={17.92} y={0}>
            {'P'}
          </tspan>
          <tspan x={27.42} y={0}>
            {' File'}
          </tspan>
          <tspan className='choose6_svg__cls-7' x={55.77} y={0} />
          <tspan x={59.78} y={0} letterSpacing='-.01em'>
            {'T'}
          </tspan>
          <tspan x={68.22} y={0}>
            {'ransfer'}
          </tspan>
        </text>
        <path className='choose6_svg__cls-2' d='M43.37 23.35A21.72 21.72 0 1123.35.06a21.8 21.8 0 0120 23.29z' />
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          stroke='#7c8aa3'
          fill='none'
          d='M179.19 54.15h144.38l-8.91-8.9'
        />
        <path
          stroke='#fd5c1f'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={2}
          fill='none'
          d='M323.57 64.27H179.19l8.91 8.9'
        />
        <path
          className='choose6_svg__cls-11'
          d='M23.76 10.86a31.18 31.18 0 00-7.27 1l1.64 1.18a15.76 15.76 0 01-5.72 0v4.84a23 23 0 009.67-.88l-.76-.92a21.7 21.7 0 012.44-.08A26 26 0 0131 17v-5.11a31.31 31.31 0 00-7.24-1.03z'
        />
        <path
          className='choose6_svg__cls-12'
          d='M31.47 29.63a21.18 21.18 0 00-4.08.8v1.43a29 29 0 01-7.36.68 29.74 29.74 0 01-7.18-1.6v-5.12a21.78 21.78 0 008.87 1.78 28.65 28.65 0 005.1-.49l-.24-1.28a17.73 17.73 0 014.89-1.23zM28.29 18a25.72 25.72 0 00-5.07.61l.84 1.39a20.86 20.86 0 01-5.19.47A24.33 24.33 0 0110 18.66v5.13a25.31 25.31 0 007.76 1.34 25.65 25.65 0 008.18-1.25l-.24-.62a19.58 19.58 0 012.6-.17 21.05 21.05 0 015.23.52v-5.14a30.66 30.66 0 00-5.24-.47z'
        />
        <path className='choose6_svg__cls-2' d='M365.54 23.35a21.72 21.72 0 11-20-23.29 21.81 21.81 0 0120 23.29z' />
        <path
          className='choose6_svg__cls-11'
          d='M345.93 10.86a31.18 31.18 0 00-7.27 1l1.64 1.18a15.76 15.76 0 01-5.72 0v4.84a23 23 0 009.67-.88l-.76-.92a21.59 21.59 0 012.44-.11 26 26 0 017.27 1v-5.08a31.47 31.47 0 00-7.27-1.03z'
        />
        <path
          className='choose6_svg__cls-12'
          d='M353.64 29.63a21 21 0 00-4.08.8v1.43a29 29 0 01-7.36.68 29.74 29.74 0 01-7.18-1.6v-5.12a21.78 21.78 0 008.87 1.78 28.65 28.65 0 005.1-.49l-.25-1.28a17.81 17.81 0 014.9-1.23zM350.46 18a25.52 25.52 0 00-5.07.61l.84 1.35a20.9 20.9 0 01-5.19.47 24.33 24.33 0 01-8.92-1.78v5.13a25.31 25.31 0 007.76 1.34 25.7 25.7 0 008.18-1.25l-.24-.62a19.58 19.58 0 012.6-.17 21.05 21.05 0 015.23.52v-5.13a30.66 30.66 0 00-5.19-.47z'
        />
        <path
          className='choose6_svg__cls-11'
          d='M277.44 56.08A26.06 26.06 0 11251.38 30a26.18 26.18 0 0126.06 26.06z'
        />
        <path
          d='M251.39 73a4.09 4.09 0 01-1.2-.25 20.62 20.62 0 01-8.9-7 21.25 21.25 0 01-3.55-8.34 25.86 25.86 0 01-.09-10.05 2.86 2.86 0 011.49-1.79 3 3 0 012.31-.27c1.53.5 3.14.2 5.05-1a11.72 11.72 0 002.61-2 3 3 0 012.49-.91 2.94 2.94 0 012 .82 2.4 2.4 0 01.34.28l.17.15a16.17 16.17 0 002.31 1.76 6.17 6.17 0 005 .94 2.74 2.74 0 012.42.3 3.21 3.21 0 011.35 1.82l.06.55a27.9 27.9 0 01-.22 9.31 22.35 22.35 0 01-3.56 8.34 20.82 20.82 0 01-8.74 7 3 3 0 01-1.34.34z'
          strokeWidth={1.47}
          stroke='#fff'
          strokeMiterlimit={10}
          fill='none'
        />
        <path
          d='M255.13 54.53h-3.36V51a.67.67 0 10-1.34 0v3.54h-3.37a.68.68 0 000 1.35h3.37v6.73a.67.67 0 001.34 0v-6.74h3.36a.68.68 0 100-1.35z'
          strokeWidth={1.32}
          stroke='#fff'
          fill='#fd5c1f'
          strokeMiterlimit={10}
        />
      </g>
    </g>
  </svg>
)
export default SvgChoose6
